/**
 * @fileoverview ToggleSwitch Component
 *
 * A reusable toggle switch component with smooth animations and accessibility support.
 * Can be used anywhere in the application as a more visually appealing alternative
 * to standard checkboxes.
 *
 * @module components/shared/ToggleSwitch
 *
 * @example
 * <ToggleSwitch
 *   checked={isEnabled}
 *   onChange={(checked) => setIsEnabled(checked)}
 *   label="Enable notifications"
 * />
 */
import styles from './ToggleSwitch.module.css';

/**
 * ToggleSwitch Component
 *
 * @param {Object} props - Component props
 * @param {boolean} props.checked - Whether the toggle is on
 * @param {Function} props.onChange - Callback when toggle changes (receives boolean)
 * @param {string} props.label - Label text to display next to toggle
 * @param {string} [props.className] - Optional additional CSS class
 * @param {boolean} [props.disabled] - Whether the toggle is disabled
 */
function ToggleSwitch({ checked, onChange, label, className = '', disabled = false }) {
    return (
        <label className={`${styles.toggleLabel} ${className}`}>
            <input
                type="checkbox"
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                className={styles.toggleInput}
                disabled={disabled}
            />
            <span className={styles.toggleSwitch}>
                <span className={styles.toggleSlider}></span>
            </span>
            <span>{label}</span>
        </label>
    );
}

export default ToggleSwitch;
